import * as React from "react";

export const SkipToContent = (props: {text?: string }) => {
    return (
        <a className="SkipToContent visuallyHidden" href="#maincontent">
            {props.text}
        </a>
    );
};